module.exports = __webpack_public_path__ + "static/media/pokerImage1.b6e9d564.png";